export default "__VITE_ASSET__D$_9YC5M__"